import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { JourneyRepository } from 'src/app/repositories/journey.repository';

@Component({
  selector: 'app-popup-delete',
  templateUrl: './popup-delete.component.html',
  styleUrls: ['./popup-delete.component.css']
})
export class PopupDeleteComponent implements OnInit {

  @Output() status = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  onDeleteJourney() {
    this.status.emit(1);
  }

  closePopup() {
    this.status.emit(0);
  }

}
